import { Avatar, Box, Flex, Title } from '@mantine/core'
import Link from 'next/link'

import { useTranslation } from '@flecto/translations'
import { DropdownLanguageSelector, useMediaQuery } from '@flecto/ui'

import { useAccessibilityProps } from '../../hooks/useAccessibilityProps'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useStoreLogo } from '../../hooks/useStoreLogo'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import { DropdownBasket } from '../DropdownBasket/DropdownBasket'
import { DropdownSelectDates } from '../DropdownSelectDates/DropdownSelectDates'
import { Search } from './Search'
import styles from './styles.module.css'

export type HeaderProps = {
  withDates?: boolean
  withBasket?: boolean
  withSearch?: boolean
  withLanguages?: boolean
}

export function Header({
  withDates = true,
  withBasket = true,
  withSearch = true,
  withLanguages = true,
}: HeaderProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })
  const { isDesktop } = useMediaQuery()
  const store = useStoreDetails()
  const path = useStorePathBuilder()
  const logo = useStoreLogo()
  const urlIndex = path('/')
  const urlCatalog = path('/items')
  const acessibilityProps = useAccessibilityProps({
    type: 'logo',
    content: store?.name ?? '',
  })

  return (
    <Box className={styles.header}>
      <Box className={styles.container}>
        <Link href={urlIndex} className={styles.logo}>
          <Flex align='center' gap='sm'>
            {logo && (
              <Avatar
                src={logo}
                className={styles.logoForm}
                h={isDesktop ? 40 : 34}
                w={isDesktop ? 40 : 34}
                {...acessibilityProps}
              />
            )}
            {!logo && (
              <Title order={5} className={styles.logoName}>
                {store?.name}
              </Title>
            )}
          </Flex>
        </Link>
        <Title
          // @ts-expect-error missing Prop
          href={urlCatalog}
          component={Link}
          className={styles.catalog}
          order={5}
          c='gray.8'
        >
          {t('header.label_catalog')}
        </Title>
        {withSearch && <Search />}
        {withDates && <DropdownSelectDates className={styles.dates} />}
        {withBasket && <DropdownBasket className={styles.basket} />}
        {withLanguages && (
          <DropdownLanguageSelector
            size={isDesktop ? 'md' : 'sm'}
            position='bottom-end'
            className={styles.language}
            withSyncUser={false}
          />
        )}
      </Box>
    </Box>
  )
}
